module.exports = __webpack_public_path__ + "img/fsin.c7d52f9f.svg";